import type { SVGProps } from 'react';

export type IconName =
  | 'today'
  | 'inbox'
  | 'proposal'
  | 'arbitration'
  | 'folder'
  | 'meeting'
  | 'action'
  | 'calendar'
  | 'search'
  | 'notification'
  | 'admin'
  | 'account'
  | 'menu'
  | 'close'
  | 'microphone'
  | 'plus'
  | 'arrow';

const paths: Record<IconName, string> = {
  today: 'M4 4h16v16H4z M8 8h3v3H8z M13 8h3 M13 12h3 M8 15h8',
  inbox: 'M4 5h16v13H4z M4 13h5l2 2h2l2-2h5',
  proposal: 'M8 4h8l3 3v13H5V4z M8 9h8 M8 13h8 M8 17h5',
  arbitration: 'M12 3v18 M5 7h14 M7 7l-3 6h6z M17 7l-3 6h6z',
  folder: 'M3 6h7l2 2h9v11H3z',
  meeting:
    'M7 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M17 10a2.5 2.5 0 1 0 0-5 M2 20v-3a5 5 0 0 1 10 0v3 M14 14a4 4 0 0 1 8 3v3',
  action: 'M5 12l4 4L19 6',
  calendar: 'M5 4h14v16H5z M8 2v4 M16 2v4 M5 9h14',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14z M16 16l5 5',
  notification: 'M6 16h12l-2-3V9a4 4 0 0 0-8 0v4z M10 20h4',
  admin:
    'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z M4 12h2 M18 12h2 M12 4V2 M12 22v-2 M6 6l1.5 1.5 M16.5 16.5L18 18 M18 6l-1.5 1.5 M7.5 16.5L6 18',
  account: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M4 21a8 8 0 0 1 16 0',
  menu: 'M4 7h16 M4 12h16 M4 17h16',
  close: 'M6 6l12 12 M18 6L6 18',
  microphone: 'M9 5a3 3 0 0 1 6 0v7a3 3 0 0 1-6 0z M5 11a7 7 0 0 0 14 0 M12 18v4',
  plus: 'M12 5v14 M5 12h14',
  arrow: 'M5 12h14 M14 7l5 5-5 5',
};

export function Icon({ name, ...props }: SVGProps<SVGSVGElement> & { name: IconName }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d={paths[name]} />
    </svg>
  );
}
